/*
  import UndrawAccessAccount from './undraw_access_account_re_8spm.svg'
  import UndrawAccessDenied from './undraw_access_denied_6w73.svg'
  import UndrawBestPlace, {
    ReactComponent as UndrawBestPlaceComponent,
  } from './undraw_best_place_re_lne9.svg'
  import UndrawBloggingVpvv from './undraw_blogging_vpvv.svg'
  import UndrawBooked from './undraw_booked_re_vtod.svg'
  import UndrawBusinessShopBasketball, {
    ReactComponent as UndrawBusinessShopBasketballComponent,
  } from './undraw_business_shop_basketball.svg'
  import UndrawChildren, {
    ReactComponent as UndrawChildrenComponent,
  } from './undraw_children_4rtb.svg'
  import UndrawDiscount from './undraw_discount_d-4-bd.svg'
  import UndrawEmptyCart from './undraw_empty_cart_co35.svg'
  import UndrawEvents from './undraw_events_2p66.svg'
  import UndrawFilter from './undraw_filter_4kje.svg'
  import UndrawFriendship from './undraw_friendship_mni7.svg'
  import UndrawHalloween from './undraw_halloween_re_2kq1.svg'
  import UndrawInboxCleanup from './undraw_inbox_cleanup_re_jcbh.svg'
  import UndrawMailbox from './undraw_mailbox_re_dvds.svg'
  import UndrawMessageSent, {
    ReactComponent as UndrawMessageSentComponent,
  } from './undraw_message_sent_re_q2kl.svg'
  import UndrawMultitasking from './undraw_multitasking_hqg3.svg'
  import UndrawNewsletter, {
    ReactComponent as UndrawNewsletterComponent,
  } from './undraw_newsletter_re_wrob.svg'
  import UndrawOnlinePayments from './undraw_online_payments_re_y8f2.svg'
  import UndrawPayOnline from './undraw_pay_online_b1hk.svg'
  import UndrawPeopleSearch from './undraw_people_search_re_5rre.svg'
  import UndrawPeopleSearch2 from './undraw_people_search_wctu.svg'
  import UndrawReceipt from './undraw_receipt_re_fre3.svg'
  import UndrawResearching from './undraw_researching_22gp.svg'
  import UndrawReviewedDocs from './undraw_reviewed_docs_neeb.svg'
  import UndrawRoadSign from './undraw_road_sign_mfpo.svg'
  import UndrawRunningWild, {
    ReactComponent as UndrawRunningWildComponent,
  } from './undraw_running_wild_ni0y.svg'
  import UndrawSelectOption from './undraw_select_option_y75i.svg'
  import UndrawSelectingTeam from './undraw_selecting_team_8uux.svg'
  import UndrawSnowGames from './undraw_snow_games_ohkc.svg'
  import UndrawTeachingJuniorSoccer, {
    ReactComponent as UndrawTeachingJuniorSoccerComponent,
    } from './undraw_teaching_junior_soccer.svg'
    import UndrawWarning from './undraw_warning_cyit.svg'
    import UndrawWebSearch from './undraw_web_search_eetr.svg'
    import UndrawWorkTogether from './undraw_work_together_h63l.svg'
    */
import UndrawSorry from './undraw_sorry.svg'

// Temporarily remove Undraw images until adequate replacements are found
import * as React from 'react'

const emptyImage = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
export const emptyComponent: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & { title?: string }
> = () => <img src={emptyImage} alt="empty" />

export {
  emptyImage as UndrawAccessAccount,
  emptyImage as UndrawAccessDenied,
  emptyImage as UndrawBestPlace,
  emptyComponent as UndrawBestPlaceComponent,
  emptyImage as UndrawBloggingVpvv,
  emptyImage as UndrawBooked,
  emptyImage as UndrawBusinessShopBasketball,
  emptyComponent as UndrawBusinessShopBasketballComponent,
  emptyImage as UndrawChildren,
  emptyComponent as UndrawChildrenComponent,
  emptyImage as UndrawDiscount,
  emptyImage as UndrawEmptyCart,
  emptyImage as UndrawEvents,
  emptyImage as UndrawFilter,
  emptyImage as UndrawFriendship,
  emptyImage as UndrawHalloween,
  emptyImage as UndrawInboxCleanup,
  emptyImage as UndrawMailbox,
  emptyImage as UndrawMessageSent,
  emptyComponent as UndrawMessageSentComponent,
  emptyImage as UndrawMultitasking,
  emptyImage as UndrawNewsletter,
  emptyComponent as UndrawNewsletterComponent,
  emptyImage as UndrawOnlinePayments,
  emptyImage as UndrawPayOnline,
  emptyImage as UndrawPeopleSearch,
  emptyImage as UndrawPeopleSearch2,
  emptyImage as UndrawReceipt,
  emptyImage as UndrawResearching,
  emptyImage as UndrawReviewedDocs,
  emptyImage as UndrawRoadSign,
  emptyImage as UndrawRunningWild,
  emptyComponent as UndrawRunningWildComponent,
  emptyImage as UndrawSelectOption,
  emptyImage as UndrawSelectingTeam,
  emptyImage as UndrawSnowGames,
  UndrawSorry,
  emptyImage as UndrawTeachingJuniorSoccer,
  emptyComponent as UndrawTeachingJuniorSoccerComponent,
  emptyImage as UndrawWarning,
  emptyImage as UndrawWebSearch,
  emptyImage as UndrawWorkTogether,
}
